import Wrapper from '@/components/base/Wrapper';
import MenuList from '@/components/menu/Menu';
import ClassSection from '@/components/menu/ClassSection';
import SuccessPage from '@/pages/Success';
import MenuLite from '@/components/menu/MenuLite';

const attendance = {
  path: 'attendance',
  component: Wrapper,
  meta: { breadCrumb: 'content.attendance_list' },
  props: { type: 'teacher' },
  children: [
    {
      path: '',
      name: 'TeacherAttendanceIndex',
      component: () => import(/* webpackChunkName: "teacher-attendance-index" */ '@/pages/attendance-creator/index'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.attendance' },
      props: { type: 'teacher' }
    },
    {
      path: 'create',
      name: 'TeacherAttendanceList',
      component: () => import(/* webpackChunkName: "teacher-attendance-form" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { type: 'teacher' }
    },
    {
      path: 'edit/:id',
      name: 'TeacherAttendanceListEdit',
      component: () => import(/* webpackChunkName: "teacher-attendance-form" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { type: 'teacher' }
    },
    {
      path: 'view/:id',
      name: 'TeacherAttendanceListView',
      component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { editable: false, type: 'teacher' }
    },
    {
      path: 'success',
      name: 'TeacherAttendanceSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'attendance-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherAttendanceUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'attendance-teacher-update' }
    }
  ]
};

const assignment = {
  path: 'assignment',
  component: Wrapper,
  meta: { breadCrumb: 'menu.assignment_list' },
  props: { type: 'teacher' },
  children: [
    {
      path: '',
      name: 'TeacherAssignment',
      component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/index'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { type: 'teacher' }
    },
    {
      path: 'create',
      name: 'TeacherAssignmentCreate',
      component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/assignment-creator/Create'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.assigment_create' },
      props: { type: 'teacher' }
    },
    {
      path: ':assignmentId/edit',
      name: 'TeacherAssignmentEdit',
      component: () => import(/* webpackChunkName: "teacher-attendance-form" */ '@/pages/assignment-creator/Create'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.assigment_create' },
      props: { type: 'teacher' }
    },
    {
      path: ':assignmentId/detail',
      component: Wrapper,
      meta: { breadCrumb: 'content.assignment_detail' },
      children: [
        {
          path: '',
          name: 'TeacherAssignmentDetail',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/detail'),
          meta: { rule: 'isTeacher', layout: 'default' },
          props: { type: 'teacher' }
        },
        {
          path: 'scorefile',
          name: 'TeacherAssignmentScoreFile',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/ScoreFile'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.assignment_score' },
          props: { type: 'teacher' }
        },
        {
          path: 'quizattempt',
          name: 'TeacherAssignmentQuizAttempt',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/QuizAttempt'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.assignment_detail' },
          props: { type: 'teacher' }
        },
        {
          path: 'scorequiz',
          name: 'TeacherAssignmentScoreQuiz',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/ScoreQuiz'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.assignment_score' },
          props: { type: 'teacher' }
        },
        {
          path: 'curvegrading',
          name: 'TeacherAssignmentCurveGrading',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/Grading'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.assignment_grading' },
          props: { type: 'teacher' }
        },
        {
          path: 'success',
          name: 'TeacherGrupAssignmentSuccessGrading',
          component: SuccessPage,
          meta: { rule: 'isTeacher' },
          props: { type: 'assign-teacher-grading' }
        },
        {
          path: 'success',
          name: 'TeacherGrupAssignmentSuccessScoreFile',
          component: SuccessPage,
          meta: { rule: 'isTeacher' },
          props: { type: 'assign-teacher-score-file' }
        }
      ]
    },
    {
      path: 'success',
      name: 'TeacherAssignmentSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'assign-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherAssignmentUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'assign-update-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherGrupAssignmentSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'grup-assign-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherGrupAssignmentUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'grup-assign-teacher-update' }
    }
  ]
};

const files = {
  path: 'file',
  name: 'TeacherFile',
  component: () => import(/* webpackChunkName: "teacher-file" */ '@/pages/files'),
  meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.files' },
  props: { editable: true }
};

const quiz = {
  path: 'quiz-creator',
  component: Wrapper,
  meta: { breadCrumb: 'menu.manage_quiz' },
  children: [
    {
      path: '',
      name: 'QuizTeacherIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/quiz-creator'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'QuizTeacherCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.create_quiz' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      name: 'QuizTeacherEditClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_quiz' },
      props: { isClass: true }
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_quiz' },
      children: [
        {
          path: '',
          name: 'QuizTeacherViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/quiz-creator/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default' },
          props: { editable: false, isClass: true }
        },
        {
          path: 'quizstats',
          name: 'TeacherQuizStatsClass',
          component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/QuizStats'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.quiz_stastiktik' },
          props: { isClass: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'QuizTeacherSuccessClass',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'quiz-teacher-class' }
    },
    {
      path: 'success',
      name: 'QuizTeacherUpdateSuccessClass',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'quiz-teacher-update-class' }
    }
  ]
};

const discussion = {
  path: 'discussion',
  component: Wrapper,
  meta: { breadCrumb: 'content.discussion' },
  children: [
    {
      path: '',
      name: 'DiscussionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/forum'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'DiscussionCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/forum/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_discussion' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'DiscussionEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_discussion' },
          props: { isClass: true }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'DiscussionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/View'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.view_discussion' },
          props: { isClass: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'DiscussionTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'discussion-teacher' }
    },
    {
      path: 'success',
      name: 'DiscussionTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'discussion-teacher-update' }
    }
  ]
};

const syllabus = {
  path: 'syllabus',
  component: Wrapper,
  meta: { breadCrumb: 'content.view_syllabus' },
  children: [
    {
      path: '',
      name: 'SyllabusIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/syllabus/StudentView'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    }
  ]
};

const pages = {
  path: 'pages',
  component: Wrapper,
  meta: { breadCrumb: 'content.pages' },
  children: [
    {
      path: '',
      name: 'PagesIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/page'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'PagesCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/page/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_pages' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'PagesEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/page/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_pages' },
          props: { isClass: true, isEditable: false }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'PagesViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/page/StudentView'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.view_pages' },
          props: { isClass: true, isEditable: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'PagesTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'pages-teacher' }
    },
    {
      path: 'success',
      name: 'PagesTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'pages-teacher-update' }
    }
  ]
};

const list_teacher = {
  path: 'list-teacher',
  component: Wrapper,
  meta: { breadCrumb: 'content.people' },
  children: [
    {
      path: '',
      name: 'ListTeacherIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/list-teacher'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    }
  ]
};

const list_student = {
  path: 'list-student',
  component: Wrapper,
  meta: { breadCrumb: 'content.list_student' },
  children: [
    {
      path: '',
      name: 'ListStudentIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/list-student'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    }
  ]
};

const modules = {
  path: 'modules',
  component: Wrapper,
  meta: { breadCrumb: 'content.modules' },
  children: [
    {
      path: '',
      name: 'ModulesIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/modules'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'ModulesCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/modules/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_modules' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'ModulesEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/modules/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_modules' },
          props: { isClass: true, isEditable: false }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_modules' },
      children: [
        {
          path: '',
          name: 'ModulesViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/modules/StudentView'),
          meta: { rule: 'isTeacher', layout: 'default' },
          props: { isClass: true, isEditable: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'ModulesTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'modules-teacher' }
    },
    {
      path: 'success',
      name: 'ModulesTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'modules-teacher-update' }
    }
  ]
};

const announcement = {
  path: 'announcement',
  component: Wrapper,
  meta: { breadCrumb: 'content.announcement' },
  children: [
    {
      path: '',
      name: 'AnnouncementIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/announcement'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'AnnouncementCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/announcement/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_announcement' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'AnnouncementEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_announcement' },
          props: { isClass: true, isEditable: false }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'AnnouncementViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/StudentView'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.view_announcement' },
          props: { isClass: true, isEditable: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'AnnouncementTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'announcement-teacher' }
    },
    {
      path: 'success',
      name: 'AnnouncementTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'announcement-teacher-update' }
    }
  ]
};

const attendance_section = {
  path: 'attendance',
  component: Wrapper,
  meta: { breadCrumb: 'content.attendance_list' },
  props: { type: 'teacher' },
  children: [
    {
      path: '',
      name: 'TeacherAttendanceSectionIndex',
      component: () => import(/* webpackChunkName: "teacher-attendance-index" */ '@/pages/attendance-creator/index'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.attendance' },
      props: { type: 'teacher' }
    },
    {
      path: 'create',
      name: 'TeacherAttendanceSectionList',
      component: () => import(/* webpackChunkName: "teacher-attendance-form" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { type: 'teacher' }
    },
    {
      path: 'edit/:id',
      name: 'TeacherAttendanceSectionListEdit',
      component: () => import(/* webpackChunkName: "teacher-attendance-form" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { type: 'teacher' }
    },
    {
      path: 'view/:id',
      name: 'TeacherAttendanceSectionListView',
      component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { editable: false, type: 'teacher' }
    },
    {
      path: 'success',
      name: 'TeacherAttendanceSectionSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'attendance-section-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherAttendanceSectionUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'attendance-section-teacher-update' }
    }
  ]
};

const assignment_section = {
  path: 'assignment',
  component: Wrapper,
  meta: { breadCrumb: 'menu.assignment_list' },
  props: { type: 'teacher' },
  children: [
    {
      path: '',
      name: 'TeacherAssignmentSection',
      component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/index'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { type: 'teacher' }
    },
    {
      path: 'create',
      name: 'TeacherAssignmentSectionCreate',
      component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/assignment-creator/Create'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.assigment_create' },
      props: { type: 'teacher' }
    },
    {
      path: ':assignmentId/edit',
      name: 'TeacherAssignmentSectionEdit',
      component: () => import(/* webpackChunkName: "teacher-attendance-form" */ '@/pages/assignment-creator/Create'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.assigment_create' },
      props: { type: 'teacher' }
    },
    {
      path: ':assignmentId/detail',
      component: Wrapper,
      meta: { breadCrumb: 'content.assignment_detail' },
      children: [
        {
          path: '',
          name: 'TeacherAssignmentSectionDetail',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/detail'),
          meta: { rule: 'isTeacher', layout: 'default' },
          props: { type: 'teacher' }
        },
        {
          path: 'scorefile',
          name: 'TeacherAssignmentSectionScoreFile',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/ScoreFile'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.assignment_score' },
          props: { type: 'teacher' }
        },
        {
          path: 'quizattempt',
          name: 'TeacherAssignmentSectionQuizAttempt',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/QuizAttempt'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.assignment_detail' },
          props: { type: 'teacher' }
        },
        {
          path: 'scorequiz',
          name: 'TeacherAssignmentSectionScoreQuiz',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/ScoreQuiz'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.assignment_score' },
          props: { type: 'teacher' }
        },
        {
          path: 'curvegrading',
          name: 'TeacherAssignmentSectionCurveGrading',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/Grading'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.assignment_grading' },
          props: { type: 'teacher' }
        },
        {
          path: 'success',
          name: 'TeacherGrupAssignmentSectionSuccessGrading',
          component: SuccessPage,
          meta: { rule: 'isTeacher' },
          props: { type: 'assign-teacher-section-grading' }
        },
        {
          path: 'success',
          name: 'TeacherGrupAssignmentSectionSuccessScoreFile',
          component: SuccessPage,
          meta: { rule: 'isTeacher' },
          props: { type: 'assign-teacher-score-file' }
        }
      ]
    },
    {
      path: 'success',
      name: 'TeacherAssignmentSectionSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'assign-section-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherAssignmentSectionUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'assign-update-section-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherGrupAssignmentSectionSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'grup-assign-teacher' }
    },
    {
      path: 'success',
      name: 'TeacherGrupAssignmentSectionUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'grup-assign-teacher-update' }
    }
  ]
};

const files_section = {
  path: 'file',
  name: 'TeacherSectionFile',
  component: () => import(/* webpackChunkName: "teacher-file" */ '@/pages/files'),
  meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.files' },
  props: { editable: true }
};

const quiz_section = {
  path: 'quiz-creator',
  component: Wrapper,
  meta: { breadCrumb: 'menu.manage_quiz' },
  children: [
    {
      path: '',
      name: 'QuizTeacherSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/quiz-creator'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'QuizTeacherSectionCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.create_quiz' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      name: 'QuizTeacherSectionEditClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_quiz' },
      props: { isClass: true }
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_quiz' },
      children: [
        {
          path: '',
          name: 'QuizTeacherSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/quiz-creator/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default' },
          props: { editable: false, isClass: true }
        },
        {
          path: 'quizstats',
          name: 'TeacherSectionQuizStatsClass',
          component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/QuizStats'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.quiz_stastiktik' },
          props: { isClass: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'QuizTeacherSectionSuccessClass',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'quiz-teacher-section-class' }
    },
    {
      path: 'success',
      name: 'QuizTeacherSectionUpdateSuccessClass',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'quiz-teacher-section-update-class' }
    }
  ]
};

const discussion_section = {
  path: 'discussion',
  component: Wrapper,
  meta: { breadCrumb: 'content.discussion' },
  children: [
    {
      path: '',
      name: 'DiscussionSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/forum'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'DiscussionSectionCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/forum/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_discussion' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'DiscussionSectionEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_discussion' },
          props: { isClass: true }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'DiscussionSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/View'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.view_discussion' },
          props: { isClass: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'DiscussionSectionTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'discussion-teacher-section' }
    },
    {
      path: 'success',
      name: 'DiscussionSectionTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'discussion-teacher-section-update' }
    }
  ]
};

const syllabus_section = {
  path: 'syllabus',
  component: Wrapper,
  meta: { breadCrumb: 'content.view_syllabus' },
  children: [
    {
      path: '',
      name: 'SyllabusSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/syllabus/StudentView'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    }
  ]
};

const pages_section = {
  path: 'pages',
  component: Wrapper,
  meta: { breadCrumb: 'content.pages' },
  children: [
    {
      path: '',
      name: 'PagesSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/page'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'PagesSectionCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/page/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_pages' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'PagesSectionEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/page/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_pages' },
          props: { isClass: true, isEditable: false }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'PagesSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/page/StudentView'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.view_pages' },
          props: { isClass: true, isEditable: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'PagesSectionTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'pages-teacher-section' }
    },
    {
      path: 'success',
      name: 'PagesSectionTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'pages-teacher-section-update' }
    }
  ]
};

const list_teacher_section = {
  path: 'list-teacher',
  component: Wrapper,
  meta: { breadCrumb: 'content.people' },
  children: [
    {
      path: '',
      name: 'ListTeacherSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/list-teacher'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    }
  ]
};

const list_student_section = {
  path: 'list-student',
  component: Wrapper,
  meta: { breadCrumb: 'content.list_student' },
  children: [
    {
      path: '',
      name: 'ListStudentSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/list-student'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    }
  ]
};

const modules_section = {
  path: 'modules',
  component: Wrapper,
  meta: { breadCrumb: 'content.modules' },
  children: [
    {
      path: '',
      name: 'ModulesSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/modules'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'ModulesSectionCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/modules/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_modules' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'ModulesSectionEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/modules/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_modules' },
          props: { isClass: true, isEditable: false }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_modules' },
      children: [
        {
          path: '',
          name: 'ModulesSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/modules/StudentView'),
          meta: { rule: 'isTeacher', layout: 'default' },
          props: { isClass: true, isEditable: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'ModulesSectionTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'modules-teacher-section' }
    },
    {
      path: 'success',
      name: 'ModulesSectionTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'modules-teacher-section-update' }
    }
  ]
};

const announcement_section = {
  path: 'announcement',
  component: Wrapper,
  meta: { breadCrumb: 'content.announcement' },
  children: [
    {
      path: '',
      name: 'AnnouncementSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/announcement'),
      meta: { rule: 'isTeacher', layout: 'default' },
      props: { isClass: true }
    },
    {
      path: 'create',
      name: 'AnnouncementSectionCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/announcement/CreateEdit'),
      meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_announcement' },
      props: { isClass: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'AnnouncementSectionEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/CreateEdit'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_announcement' },
          props: { isClass: true, isEditable: false }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'AnnouncementSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/StudentView'),
          meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.view_announcement' },
          props: { isClass: true, isEditable: true }
        }
      ]
    },
    {
      path: 'success',
      name: 'AnnouncementSectionTeacherSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'announcement-teacher-section' }
    },
    {
      path: 'success',
      name: 'AnnouncementSectionTeacherUpdateSuccess',
      component: SuccessPage,
      meta: { rule: 'isTeacher' },
      props: { type: 'announcement-teacher-section-update' }
    }
  ]
};

export default [
  // Teacher :: Class
  {
    path: '/teacher-class',
    component: Wrapper,
    meta: { breadCrumb: 'content.class_list' },
    children: [
      {
        path: '',
        name: 'TeacherClassIndex',
        component: () => import(/* webpackChunkName: "teacher-class" */ '@/components/menu/Class'),
        meta: { rule: 'isTeacher', layout: 'default' },
        props: { type: 'teacher' }
      },
      {
        path: 'class/:classId',
        component: Wrapper,
        meta: { breadCrumb: 'content.class_title' },
        children: [
          {
            path: '',
            name: 'TeacherCourseList',
            component: () => import(/* webpackChunkName: "teacher-course" */ '@/components/menu/Course'),
            meta: { rule: 'isTeacher', layout: 'default' },
            props: { type: 'teacher' }
          },
          {
            path: 'erapor',
            component: Wrapper,
            meta: { breadCrumb: 'content.erapor' },
            children: [
              {
                path: '',
                name: 'EraporTeacherView',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/ListStudent'),
                meta: { rule: 'isTeacher', layout: 'default' },
                props: { type: 'teacher' }
              },
              {
                path: 'view/:studentId',
                name: 'eRaporGeneratorViewStudentClass',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/Template'),
                meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_generate_view' },
                props: { type: 'teacher', isEditable: false }
              }
            ]
          },
          {
            path: 'course/:courseId',
            component: Wrapper,
            meta: { breadCrumb: 'table.menu' },
            children: [
              {
                path: '',
                name: 'TeacherMenuList',
                component: MenuList,
                meta: { rule: 'isTeacher', layout: 'default' },
                props: { type: 'teacher' }
              },
              modules,
              pages,
              quiz,
              discussion,
              assignment,
              attendance,
              files,
              syllabus,
              announcement,
              list_teacher,
              list_student
            ]
          },
          {
            path: 'course/:courseId/sectionclass',
            component: Wrapper,
            meta: { breadCrumb: 'content.class_section' },
            children: [
              {
                path: '',
                name: 'TeacherClassSectionList',
                component: ClassSection,
                meta: { rule: 'isTeacher', layout: 'default' },
                props: { type: 'teacher' }
              },
              {
                path: ':classSectionId',
                component: Wrapper,
                meta: { breadCrumb: 'table.menu' },
                children: [
                  {
                    path: '',
                    name: 'TeacherMenuSectionList',
                    component: MenuList,
                    meta: { rule: 'isTeacher', layout: 'default' },
                    props: { type: 'teacher' }
                  },
                  modules_section,
                  pages_section,
                  quiz_section,
                  discussion_section,
                  assignment_section,
                  attendance_section,
                  files_section,
                  syllabus_section,
                  announcement_section,
                  list_teacher_section,
                  list_student_section
                ]
              }
            ]
          }
        ]
      }
    ]
  },

  // Teacher :: Report Storage

  {
    path: '/report-storage',
    component: Wrapper,
    meta: { breadCrumb: 'content.report_storage' },
    children: [
      {
        path: '',
        name: 'ReportStorageIndex',
        component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/report-storage'),
        meta: { rule: 'isTeacher', layout: 'default' }
      }
    ]
  },

  // Teacher :: Bank Soal

  {
    path: '/bank-soal',
    component: Wrapper,
    meta: { breadCrumb: 'content.bank_soal_ic' },
    children: [
      {
        path: '',
        name: 'BankSoalIndex',
        component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/bank-soal'),
        meta: { rule: 'isTeacher', layout: 'default' }
      },
      {
        path: 'view/:id',
        component: Wrapper,
        meta: { breadCrumb: 'content.bank_soal_ic_view' },
        children: [
          {
            path: '',
            name: 'BankSoalView',
            component: () => import(/* webpackChunkName: "assignment" */ '@/pages/bank-soal/CreateEdit'),
            meta: { rule: 'isTeacher', layout: 'default' },
            props: { editable: false }
          }
        ]
      }
    ]
  },

  // Teacher :: Schedule
  {
    path: '/teacher-schedule',
    name: 'TeacherSchedule',
    component: () => import(/* webpackChunkName: "schedule-index" */ '@/pages/schedule'),
    meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'menu.schedule' }
  },

  // Teacher :: discussion
  {
    path: '/syllabus',
    component: Wrapper,
    meta: { breadCrumb: 'content.syllabus' },
    children: [
      {
        path: '',
        name: 'SyllabusIndex',
        component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/syllabus'),
        meta: { rule: 'isTeacher', layout: 'default' }
      },
      {
        path: 'create',
        name: 'SyllabusCreate',
        component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/syllabus/CreateEdit'),
        meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.add_syllabus' }
      },
      {
        path: 'edit/:id',
        component: Wrapper,
        children: [
          {
            path: '',
            name: 'SyllabusEdit',
            component: () => import(/* webpackChunkName: "assignment" */ '@/pages/syllabus/CreateEdit'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_syllabus' }
          }
        ]
      },
      {
        path: 'view/:id',
        component: Wrapper,
        children: [
          {
            path: '',
            name: 'SyllabusView',
            component: () => import(/* webpackChunkName: "assignment" */ '@/pages/syllabus/CreateEdit'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.view_syllabus' },
            props: { isEditable: true }
          }
        ]
      },
      {
        path: 'success',
        name: 'SyllabusTeacherSuccess',
        component: SuccessPage,
        meta: { rule: 'isTeacher' },
        props: { type: 'syllabus-teacher' }
      },
      {
        path: 'success',
        name: 'SyllabusTeacherUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isTeacher' },
        props: { type: 'syllabus-teacher-update' }
      }
    ]
  },

  // Teacher :: Quiz
  {
    path: '/quiz-creator',
    component: Wrapper,
    meta: { breadCrumb: 'menu.manage_quiz' },
    children: [
      {
        path: '',
        name: 'QuizTeacherIndex',
        component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/quiz-creator'),
        meta: { rule: 'isTeacher', layout: 'default' }
      },
      {
        path: 'create',
        name: 'QuizTeacherCreate',
        component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/CreateEdit'),
        meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.create_quiz' }
      },
      {
        path: 'edit/:id',
        name: 'QuizTeacherEdit',
        component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/CreateEdit'),
        meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.edit_quiz' }
      },
      {
        path: 'view/:id',
        component: Wrapper,
        meta: { breadCrumb: 'content.view_quiz' },
        children: [
          {
            path: '',
            name: 'QuizTeacherView',
            component: () => import(/* webpackChunkName: "assignment" */ '@/pages/quiz-creator/CreateEdit'),
            meta: { rule: 'isTeacher', layout: 'default' },
            props: { editable: false }
          },
          {
            path: 'quizstats',
            name: 'TeacherQuizStats',
            component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/quiz-creator/QuizStats'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.quiz_stastiktik' }
          }
        ]
      },
      {
        path: 'success',
        name: 'QuizTeacherSuccess',
        component: SuccessPage,
        meta: { rule: 'isTeacher' },
        props: { type: 'quiz-teacher' }
      },
      {
        path: 'success',
        name: 'QuizTeacherUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isTeacher' },
        props: { type: 'quiz-teacher-update' }
      }
    ]
  },

  // Teacher :: E-rapor
  {
    path: '/e-rapor',
    component: Wrapper,
    meta: { breadCrumb: 'content.e_rapor' },
    children: [
      {
        path: '',
        name: 'eRaporIndex',
        component: MenuLite,
        meta: { rule: 'isTeacher', layout: 'default' },
        props: { type: 'teacher' }
      },
      {
        path: 'template-erapor',
        component: Wrapper,
        meta: { breadCrumb: 'content.template_e_rapor' },
        children: [
          {
            path: '',
            name: 'eRaporTemplateIndex',
            component: () => import(/* webpackChunkName: "template-e-rapor" */ '@/pages/template_generator'),
            meta: { rule: 'isTeacher', layout: 'default' },
            props: { editable: false, type: 'template' }
          },
          {
            path: 'create',
            name: 'eRaporTemplateCreate',
            component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/template_generator/CreateEditTemplate'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_e_rapor_create' }
          },
          {
            path: 'edit/:id',
            name: 'eRaporTemplateEdit',
            component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/template_generator/CreateEditTemplate'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_e_rapor_edit' },
            props: { isEditable: false }
          },
          {
            path: 'view/:id',
            name: 'eRaporTemplateView',
            component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/template_generator/CreateEditTemplate'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_e_rapor_view' },
            props: { isEditable: true }
          },
          {
            path: 'success',
            name: 'eRaporTemplateSuccess',
            component: SuccessPage,
            meta: { rule: 'isTeacher' },
            props: { type: 'erapor-template-teacher' }
          },
          {
            path: 'success',
            name: 'eRaporTemplateUpdateSuccess',
            component: SuccessPage,
            meta: { rule: 'isTeacher' },
            props: { type: 'erapor-template-teacher-update' }
          }
        ]
      },
      {
        path: 'template-integ',
        component: Wrapper,
        meta: { breadCrumb: 'content.template_integ' },
        children: [
          {
            path: '',
            name: 'eRaporIntegIndex',
            component: () => import(/* webpackChunkName: "template-e-rapor" */ '@/pages/template_generator'),
            meta: { rule: 'isTeacher', layout: 'default' },
            props: { editable: false, type: 'integ' }
          },
          {
            path: 'create',
            name: 'eRaporIntegCreate',
            component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/template_generator/CreateEditIntegration'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_integ_create' }
          },
          {
            path: 'edit/:id',
            name: 'eRaporIntegEdit',
            component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/template_generator/CreateEditIntegration'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_integ_edit' },
            props: { isEditable: false }
          },
          {
            path: 'view/:id',
            name: 'eRaporIntegView',
            component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/template_generator/CreateEditIntegration'),
            meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_integ_view' },
            props: { isEditable: true }
          },
          {
            path: 'success',
            name: 'eRaporIntegSuccess',
            component: SuccessPage,
            meta: { rule: 'isTeacher' },
            props: { type: 'erapor-integ-teacher' }
          },
          {
            path: 'success',
            name: 'eRaporIntegUpdateSuccess',
            component: SuccessPage,
            meta: { rule: 'isTeacher' },
            props: { type: 'erapor-integ-teacher-update' }
          }
        ]
      },
      {
        path: 'template-generator',
        component: Wrapper,
        meta: { breadCrumb: 'content.template_generate' },
        children: [
          {
            path: '',
            name: 'eRaporGeneratorIndex',
            component: () => import(/* webpackChunkName: "template-e-rapor" */ '@/pages/template_generator'),
            meta: { rule: 'isTeacher', layout: 'default' },
            props: { editable: false, type: 'generator' }
          },
          {
            path: 'view/:id',
            component: Wrapper,
            meta: { breadCrumb: 'content.list_student' },
            children: [
              {
                path: '',
                name: 'eRaporGeneratorView',
                component: () => import(/* webpackChunkName: "template-e-rapor" */ '@/pages/template_generator/StudentView'),
                meta: { rule: 'isTeacher', layout: 'default' },
                props: { editable: false, type: 'generator' }
              },
              {
                path: 'edit/:studentId',
                name: 'eRaporGeneratorEdit',
                component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/template_generator/Template'),
                meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_generate_edit' },
                props: { isEditable: true }
              },
              {
                path: 'view/:studentId',
                name: 'eRaporGeneratorViewStudent',
                component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/template_generator/Template'),
                meta: { rule: 'isTeacher', layout: 'default', breadCrumb: 'content.template_generate_view' },
                props: { isEditable: false }
              },
              {
                path: 'success',
                name: 'eRaporGeneratorSuccess',
                component: SuccessPage,
                meta: { rule: 'isTeacher' },
                props: { type: 'erapor-generator-teacher' }
              }
            ]
          }
        ]
      }
    ]
  }
];
